import { Stack } from '@findy-code/yuffie/ui/stack';

import {
  HamburgerMenuButtonItem,
  HamburgerMenuLinkItem,
} from '../../../components/hamburger-menu/hamburger-menu-item';
import styles from './incomplete-profile-hamburger-menu-list.component.module.scss';

type Props = {
  pathname: string;
  onLogout: () => void;
};

export const IncompleteProfileHamburgerMenuList = ({
  pathname,
  onLogout,
}: Props) => {
  return (
    <Stack>
      <ul className={styles.menu}>
        <HamburgerMenuLinkItem
          href="/others/inquiry"
          isCurrentPage={pathname.startsWith('/others/inquiry')}
        >
          お問い合わせ・退会
        </HamburgerMenuLinkItem>
        <HamburgerMenuButtonItem onClick={onLogout}>
          ログアウト
        </HamburgerMenuButtonItem>
      </ul>
    </Stack>
  );
};
